import React from "react";
import ContactInfo from "../components/contact/index";
import Wrapper from "../components/wrapper/index";

function Contact() {
  return (
    <Wrapper>
      <ContactInfo />
    </Wrapper>
  );
}

export default Contact;